export default __webpack_public_path__ + "static/img-contact-1999a2ab72567d7c38c77a69523525c0.png";